import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { Loader } from '@hivebrite/design-system/Loader';

import ModalWithTemplate from 'hb-react/shared/components/DesignSystem/Modal/ModalWithTemplate';

interface ScaWarningModalProps {
  displayScaWarningModal: boolean;
  handleContinueClick: () => void;
  isLoading: boolean;
}

const ScaWarningModal = ({
  displayScaWarningModal,
  handleContinueClick,
  isLoading,
}: ScaWarningModalProps) => {
  if (!displayScaWarningModal) {
    return null;
  }

  return (
    <ModalWithTemplate
      dataTestId="sca-pre-warning-modal"
      onCloseModal={handleContinueClick}
      header={s__('OrderManagement|3DS Credit Card Authentication')}
    >
      {isLoading ? (
        <Loader size={50} />
      ) : (
        <Box flex={1} flexDirection="column">
          <Box mb={2}>
            {s__(
              'OrderManagement|To enhance the security of your transaction, we use 3DS authentication. This is a step required by your bank to verify your identity.',
            )}
          </Box>
          <Box display="block" mb={2}>
            <Box as="span" display="inline" fontWeight="bold">
              {s__(
                'OrderManagement|During this process, you may see a notification indicating a charge of 0.00.',
              )}
              &nbsp;
            </Box>
            <Box as="span" display="inline">
              {s__(
                'OrderManagement|This is standard for authentication purposes and does not represent the actual charge for your order.',
              )}
            </Box>
          </Box>
          <Box mb={2}>
            {s__(
              'OrderManagement|The actual amount that will be charged is the total of your order. This step simply ensures that your payment method is securely authorized.',
            )}
          </Box>
          <Box justifyContent="flex-end" mt={8}>
            <Button onClick={handleContinueClick}>{s__('Continue')}</Button>
          </Box>
        </Box>
      )}
    </ModalWithTemplate>
  );
};

export default ScaWarningModal;
